import React from "react";


export default React.createContext({
  mode: "light",
  showContactModal: false,
  showReportModal: false,
});